import { createContext, FC, ReactNode, useContext } from "react"

const ConfigContext = createContext<any | undefined>(undefined)

interface Props {
  config: any
  children?: ReactNode
}

const ConfigProvider: FC<Props> = ({ config, children }) => (
  <ConfigContext.Provider value={config}>
    {children}
  </ConfigContext.Provider>
)

const ConfigConsumer = ConfigContext.Consumer

const useConfigContext = () => {
  const configContext = useContext(ConfigContext)
  if (!configContext) {
    throw new Error(
      "No ConfigContext.Provider found when calling useConfigContext.",
    )
  }
  return configContext
}

export { ConfigContext, ConfigConsumer, ConfigProvider, useConfigContext }
